import React, { Component } from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';

import helpers from '../utils/helpers';

// Assets
import logo from '../images/logo.svg';

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hamburgerOpen: false,
      fontChangerOpen: false,
      fontValue: 100,
    };

    this.fontValue = 100;

    const cookieFontValue = helpers.docCookies.getItem('font-changer-value');
    if (cookieFontValue != null && cookieFontValue.length) {
      this.fontValue = cookieFontValue;
    }
  }

  componentDidMount() {
    this.setState({
      hamburgerOpen: false,
    });

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }


  handleScroll = () => {
    if (window.scrollY > 80) {
      document.querySelector('.header-wrapper').className = 'header-wrapper scrolled';
    } else {
      document.querySelector('.header-wrapper').className = 'header-wrapper';
    }
  };

  handleHamburger = () => {
    const { hamburgerOpen } = this.state;

    this.setState({ hamburgerOpen: !hamburgerOpen });
  }

  render() {
    const { hamburgerOpen } = this.state;
    const { data } = this.props;
    const {
      allWpMenu: { edges: wpMenus },
    } = data;

    const renderMenuItems = (menuItems) => {
      return menuItems.map((item, key) => {
        const menuClass = item.parentId ? 'menu-subsection' : 'menu-section';
        const pageTemplate = item.connectedNode.node && item.connectedNode.node.template.templateName;
        let isHiddenPage = false;

        if ( pageTemplate && pageTemplate === 'Hidden' ) {
          isHiddenPage = true;
        }

        return (
          item && (
            !isHiddenPage ? (
              <Link key={key} to={item.path} className={`${menuClass}`} activeClassName="active" onClick={this.handleHamburger}>
                {item.label}
              </Link>
            ) : (
              <div key={key} className={`${menuClass}`}>
                {item.label}
              </div>
            )
          )
        );
      });
    };

    const renderMenuGroups = (menuGroups) => {
      return menuGroups.map((group, key) => {
        const menuItems = group.node.menuItems.nodes;

        return (
          menuItems && (
            <div key={key} className="menu-group">
              {renderMenuItems(menuItems)}
            </div>
          )
        );
      });
    };

    return (
      <header className={hamburgerOpen ? 'menu-open' : ''}>
        <div className="header-wrapper">
          <div className="container-fluid">
            <div className="flex items-center justify-between">
              <Link to='/'>
                <img className="logo" src={logo} alt="logo" />
              </Link>

              <div className="flex items-center">
                <Link to='/' className="text-sm font-bold mr-7">Annual Report 2021</Link>

                <button type="button"
                  className={hamburgerOpen ? 'hamburger open' : 'hamburger'}
                  onClick={this.handleHamburger}>
                  <div />
                  <div />
                  <div />
                </button>
              </div>
            </div>
          </div>

          { wpMenus && (
            <div className="header-menu-wrapper">
              <div className="container">
                <div className="menu-wrapper">
                  {renderMenuGroups(wpMenus)}
                </div>
              </div>
            </div>
          ) }
        </div>

        <div className="header-placeholder" />
      </header>
    );
  }
}

const headerMenuQuery = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          allWpMenu(sort: {fields: locations}) {
            edges {
              node {
                locations
                menuItems {
                  nodes {
                    label
                    parentId
                    path
                    connectedNode {
                      node {
                        ... on WpPage {
                          id
                          template {
                            templateName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}

      render={data => <Header data={data} />}
    />
  );
};

export default headerMenuQuery;
